<template>
  <div>
    <slot name="content" @click="buy"></slot>
    <!-- todo c-dialog弹窗展示订单列表 -->
    <c-base-dialog
      v-model="showOrderList"
      :option="orderListDialogOption"
      @confirm="showOrderList = false"
      @close="showOrderList = false"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="['order-list', 'order-list--default', !isMobile ? 'order-list--pc' : '']">
          <div class="order-list-content">
            <div
              v-for="(item, index) of orderList"
              :key="index"
              class="order-list-item"
              :style="orderListItemStyle"
            >
              <div class="order-list-item-header">
                <span class="order-list-item-left">{{ getLocaleDateTimeString(item.create_at) }}
                  | 订单号：{{item.order_id}}
                </span>
                <span class="order-list-item-right order-list-item-goods">{{ item.price / 100 }} 元</span>
              </div>
              <div class="order-list-item-footer">
                <span class="order-list-item-left order-list-item-goods">{{ item.goods_name }}</span>
                <span class="order-list-item-right">
                  <!-- <a class="item-link" @click="handlePay(item.order_id)">去支付</a> -->
                  <a class="item-link" @click="handleCancel(item.order_id)">取消订单</a>
                </span>
              </div>
            </div>
          </div>
          <div class="reward-page" v-if="Math.ceil(orderTotal / pageSize) > 1">
            <a @click="currentPage > 1 && currentPage--">上一页</a>
            {{ currentPage }}/{{ Math.ceil(orderTotal / pageSize) }}
            <a
              @click="(currentPage < (orderTotal / pageSize)) && currentPage++"
            >下一页</a>
          </div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>

<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

const REACH_LIMIT_RET = 40023;
const PAY_INFO_RET_MAP = {
  0: 'OK',
  40001: '参数信息错误',
  40023: '资格错误',
  40024: '查询订单错误',
  40025: '订单状态错误',
  40026: '订单已超时关闭',
  40027: '生成支付单错误',
  40029: '查询支付单错误',
  40030: '新增支付单错误',
  40031: '新增订单错误',
  40034: '缓存错误',
  40037: '支付信息获取失败',
};
const DEFAULT_RET_MESSAGE = '对不起,此次购买失败,请联系客服确认';

const UNPAID_ORDER_API_BASE = '/action/api/common/nonPayOrders';
const CANCEL_ORDER_API_BASE = '/action/api/common/cancelOrder';
const SKU_UNPAID_ORDER_API_BASE = '/action/api/common/v2/centralQueryOrders';
const SKU_CANCEL_ORDER_API_BASE = '/action/api/common/v2/centralCancelOrder';
const DEFAULT_PAY_BUSINESS = 'act';

const isSafari = () => /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

export default {
  // 区别与注册到平台的组件C开头,基础组件采用Ceiba开头
  name: 'CeibaPayment',
  components: {
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  props: {
    payId: {
      type: String,
      default: '',
    },
    // sku 相关信息初步只需要 sku.goods_list
    // sku.quantity 默认为 1，可覆盖
    // sku.zoneType, 默认为 1，可覆盖
    sku: {
      type: Object,
      default: () => ({}),
    },
    // 拉取订单信息(下单)的流程id
    payInfoFlow: {
      type: Number,
      default: 0,
    },
    // 下单购买邀请码
    inviteCode: {
      type: String,
      default: '',
    },
    // 购买渠道.产品配置的字符串.如果不填,则自动从业务map获取.心悦'1',超核'4'
    sellChannel: {
      type: String,
      default: '',
    },
    // 优惠券信息`${codeId},${batchId}`
    spInfo: {
      type: String,
      default: '',
    },
    // 售卖场景.默认为''.最终会拼接`ceiba_act_id;sellScene`,分号分割.
    sellScene: {
      type: String,
      default: '',
    },
    // 下单扩展字段
    extendParam: {
      type: Object,
      default: () => ({}),
    },
    // ceiba流程请求基础参数
    flowRootParam: {
      type: Object,
      default: () => ({}),
    },
    orderListTitle: {
      type: String,
      default: '订单记录',
    },
    // 支付流水归属.默认为`act`归属到活动.传入后覆盖
    payBusiness: {
      type: String,
      default: 'act',
    },
    // 默认选中优惠券,传noCoupons则禁用优惠券选择
    superCoupons: {
      type: String,
      default: '',
    },
    // 是否使用角色层级限量flag.默认false.如果传true，则调用查询订单\取消接口的时候会带上role信息.
    isUseRoleLimit: {
      type: Boolean,
      default: false,
    },
    // 如果传true，则屏蔽下单失败后的默认alert.提示语需要外层业务组件自行封装处理.
    isBlockOrderFailAlert: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cssPrefix: 'payment-',
      midasInfo: {},
      orderList: [],
      midasUserInfo: {},
      payInfoFlag: false,
      showOrderList: false,
      baseSellScene: '',
      pageSize: 6,
      currentPage: 1,
      orderTotal: 0,
      finalSuperCoupons: '',
    };
  },
  computed: {
    isMobile() {
      return common.platform.isIos || common.platform.isAndroid;
    },
    orderListDialogOption() {
      return Object.assign({}, this.dialogConfig, {
        header: this.orderListTitle,
        footer: false,
        height: this.deviceMode === 'pc' ? '660px' : '7.85rem',
        width: this.deviceMode === 'pc' ? '820px' : '7.2rem',
        dialogStyle: Object.assign({ color: '#000000' }, this.dialogConfig?.dialogStyle || {}),
      });
    },
    orderListItemStyle() {
      return {
        border: `1px dashed ${this.orderListDialogOption?.dialogStyle.color}`,
      };
    },
  },
  watch: {
    'currentPage'() {
      this.getUnpaidOrderList();
    },
  },
  mounted() {
    if (this.$isInEditor) return;
    this.baseSellScene = `ceiba_act_${this.$actInfo.activity_id}`;
    this.finalSuperCoupons = this.superCoupons || (this.spInfo || '');
  },
  methods: {
    /**
     * 秒时间戳转换成字符日期时间
     * @param {Number} timestamp 秒级时间戳
     */
    getLocaleDateTimeString(timestamp) {
      return `${new Date(timestamp * 1000).toLocaleDateString()} ${new Date(timestamp * 1000).toLocaleTimeString()}`;
    },
    /**
     * 通过活动SELL_SCENE拉取未付款的订单列表
     */
    async getUnpaidOrderList() {
      const postData = {
        business: this.payBusiness || DEFAULT_PAY_BUSINESS,
        sell_scene: this.sellScene ? `${this.baseSellScene};${this.sellScene}` : this.baseSellScene,
        page_size: this.pageSize,
        page_index: this.currentPage,
        sell_channel: this.sellChannel,
        role: {},
      };
      if (this.isUseRoleLimit) {
        postData.role = this.roleInfo;
      }

      if (this.payId?.length > 0) {
        // payId 模式拉取未支付订单列表
        try {
          const response = await this.$requestInstance.post(UNPAID_ORDER_API_BASE, postData);
          console.info('【PAYMENT】payId unpaid order list', response);
          this.$emit('query-unpaid-orders', { postData, response });
          if (response.ret) {
            this.$alert({
              msg: `拉取订单列表失败. ${response.msg}`,
            });
            return;
          }
          this.orderTotal = response.total;
          this.orderList = response.data;
        } catch (error) {
          console.error('【PAYMENT】payId 拉取未支付订单列表失败', error);
          this.$aegis.report({
            msg: '【PAYMENT】payId 拉取未支付订单列表 ajax 错误',
            level: this.$aegis.logType.AJAX_ERROR,
            ext1: error.message,
            ext2: this.sellScene ? `${this.baseSellScene};${this.sellScene}` : this.baseSellScene,
            ext3: this.payId,
            trace: error.stack,
          });
        }
      } else {
        // sku 模式拉取未支付订单列表
        try {
          const response = await this.$requestInstance.post(SKU_UNPAID_ORDER_API_BASE, postData);
          console.info('【PAYMENT】sku unpaind order list', response);
          this.$emit('query-unpaid-orders', { postData, response });
          if (response.ret) {
            this.$alert({
              msg: `拉取订单列表失败. ${response.msg}`,
            });
            return;
          }
          this.orderTotal = response.data?.total;
          const tempOrderList = [];
          response.data?.infoList?.forEach((order) => {
            tempOrderList.push({
              order_id: order.order_id,
              create_at: new Date(order.created_at).getTime() / 1000,
              price: order.payment_result?.total_price,
              goods_name: order.attached_info?.sku_name,
            });
          });
          this.orderList = tempOrderList;
        } catch (error) {
          console.error('【PAYMENT】sku 拉取未支付订单列表失败', error);
          this.$aegis.report({
            msg: '【PAYMENT】sku 拉取未支付订单列表 ajax 错误',
            level: this.$aegis.logType.AJAX_ERROR,
            ext1: error.message,
            ext2: this.sellScene ? `${this.baseSellScene};${this.sellScene}` : this.baseSellScene,
            ext3: this.sku.goods_list,
            trace: error.stack,
          });
        }
      }
      if (this.orderList.length > 0) {
        this.showOrderList = true;
      } else {
        this.$alert('暂未拉取到未支付订单列表,请稍后重试');
      }
    },
    async getPayInfo() {
      this.payInfoFlag = false;
      let payInfoParams = {};
      if (this.payId?.length > 0) {
        // payId 版本下单
        payInfoParams = {
          channel: 'h5', // 先写死h5
          sell_channel: this.sellChannel,
          platform: common.platform.isAndroid ? 'android' : 'ios',
          invite_code: this.inviteCode, // 是否需要不传?
          role: this.roleInfo,
          path_through: '',
          sp_info: this.spInfo, // midas券信息
          pay_id: this.payId,
          sell_scene: this.sellScene ? `${this.baseSellScene};${this.sellScene}` : this.baseSellScene,
          // game_name: '',
          // product_icon: '',
          extend_param: this.extendParam,
        };
      } else {
        // sku 版本下单
        payInfoParams = {
          channel: 'h5', // 先写死h5
          sell_channel: this.sellChannel,
          platform: common.platform.isAndroid ? 'android' : 'ios',
          invite_code: this.inviteCode, // 是否需要不传?
          role: this.roleInfo,
          path_through: '',
          sp_info: this.spInfo, // midas券信息
          goods_list: this.sku?.goods_list, // 商品信息
          quantity: parseInt(this.sku?.quantity, 10) || 1, // 商品数量
          zoneIdType: parseInt(this.sku?.zoneIdType, 10) ?? 0, // 下单 zoneIdType 可以为 0
          sell_scene: this.sellScene ? `${this.baseSellScene};${this.sellScene}` : this.baseSellScene,
          // game_name: '',
          // product_icon: '',
          extend_param: this.extendParam,
        };
      }

      // 从url中获取via|via_source|trace_id参数添加到请求参数中
      const queryVia = common.tool.getQueryparams('via');
      const queryViaSource = common.tool.getQueryparams('via_source');
      const queryTraceId = common.tool.getQueryparams('trace_id');
      if (queryVia) {
        payInfoParams.via = queryVia;
      }
      if (queryViaSource) {
        payInfoParams.via_source = queryViaSource;
      } else {
        // 补充活动自己的 via_source
        payInfoParams.via_source = this.actInfo.uo_id;
      }
      if (queryTraceId) {
        payInfoParams.trace_id = queryTraceId;
      } else {
        if (window.ceibaTraceId) {
          // 优先用ceiba自己的trace_id
          payInfoParams.trace_id = window.ceibaTraceId;
        }
      }

      // 序列化后组装流程请求参数
      const requestParams = {
        role: this.roleInfo,
        data: JSON.stringify({
          ...this.flowRootParam,
          cPayInfo: payInfoParams,
        }),
      };
      // 调用页面配置的下单流程接口
      const response = await this.flowRequest({
        flowId: this.payInfoFlow,
        params: requestParams,
      });
      this.$aegis.infoAll({
        msg: `【PAYMENT】活动页面直购-下单-${this.actInfo.activity_id}`,
        ext1: JSON.stringify(this.userInfo),
        ext2: JSON.stringify(requestParams),
        ext3: JSON.stringify(response),
      });
      this.$emit('get-pay-info', { payId: this.payId, response });
      const flowRet = response.ret; // 外部条件整体ret,非0则代表内部服务错误
      const conditionRet = response.data?.ret; // 条件内部ret, 对应多个逻辑错误码MAP
      if (this.isBlockOrderFailAlert === false) {
        // 不屏蔽  默认下单失败提示语
        if (flowRet !== 0) {
          this.$alert({
            msg: `请求错误, 请稍后重试. ${response.msg}`,
          });
          return;
        }
        if (conditionRet !== 0 && conditionRet !== REACH_LIMIT_RET) {
          this.$alert({
            msg: PAY_INFO_RET_MAP[conditionRet] || response.data?.msg || `${DEFAULT_RET_MESSAGE}`,
          });
          return;
        }
      }
      if (conditionRet === REACH_LIMIT_RET) {
        this.getUnpaidOrderList();
        this.$emit('reach-limit', this.midasInfo);
        return;
      }
      this.payInfoFlag = true;
      this.midasInfo = response.data.data;
      const superCoupons = encodeURIComponent(this.finalSuperCoupons);
      this.midasInfo = {
        ...this.midasInfo,
        _version: 'v3',
        zoneid: (this.midasInfo.zone_id || '').toString(),
        supercoupons: superCoupons,
      };
      console.info('【PAYMENT】midasInfo after get payInfo', JSON.stringify(this.midasInfo));
    },
    async buy() {
      // 获取midasInfo
      await this.getPayInfo();
      // 获取用户info
      const acctype = common.tool.getCookie('acctype');
      this.midasUserInfo = acctype === 'qq'
        ? {
          sessionid: 'uin',
          sessiontype: 'skey',
        }
        : this.getCookieInfo();
      const paymentThis = this;
      if (this.payInfoFlag === true) {
        let isSuccess = false;
        this.$emit('midas-buy', { ...this.midasInfo, ...this.midasUserInfo });
        this.$aegis.infoAll({
          msg: `【PAYMENT】活动页面直购-拉起支付-${this.actInfo.activity_id}`,
          ext1: JSON.stringify(this.userInfo),
          ext2: JSON.stringify({ ...this.midasInfo, ...this.midasUserInfo }),
        });
        window.Midas.buyGoods({
          ...this.midasInfo,
          ...this.midasUserInfo,
          onSuccess() {
            isSuccess = true;
          },
          onClose() {
            if (isSuccess) {
              paymentThis.$emit('pay-success', paymentThis.midasInfo);
              return;
            }
            // 用户关闭支付
            paymentThis.$emit('pay-close', paymentThis.midasInfo);
          },
        });
      }
    },
    /**
     * @description 获取用户登录态信息
     * @params midasInfo 后台返回的米大师信息
     */
    getCookieInfo() {
      const { session_id, session_type } = this.midasInfo;
      console.info('【PAYMENT】session_id in payInfo', session_id);
      console.info('【PAYMENT】session_type in payInfo', session_type);
      const sessionId = session_id || (common.tool.getCookie('acctype') === 'wx' ? 'hy_gameid' : 'openid');
      const sessionType = session_type || (common.tool.getCookie('acctype') === 'wx' ? 'wc_actoken' : 'kp_accesstoken');
      console.info('【PAYMENT】platform isWX', common.platform.isWX);
      console.info('【PAYMENT】tool acctype', common.tool.getCookie('acctype'));
      console.info('【PAYMENT】session_id final', sessionId);
      console.info('【PAYMENT】session_type final', sessionType);
      return {
        openid: common.tool.getCookie('openid'),
        openkey: common.tool.getCookie('access_token'),
        sessionid: sessionId,
        sessiontype: sessionType,
        wxAppid2: common.platform.isWX || isSafari() ? common.tool.getCookie('appid') : '',
      };
    },
    /**
     * @description 取消订单
     * @params orderId 订单id
     */
    async handleCancel(orderId) {
      console.log(`【PAYMENT】handleCancel orderId=${orderId}`);
      const postData = {
        business: this.payBusiness || DEFAULT_PAY_BUSINESS,
        order_id: orderId,
        role: {},
      };
      if (this.isUseRoleLimit) {
        postData.role = this.roleInfo;
      }
      if (this.payId?.length > 0) {
        // payId 模式取消订单
        try {
          const response = await this.$requestInstance.post(CANCEL_ORDER_API_BASE, postData);
          console.info('【PAYMENT】order cancel response', response);
          this.$emit('cancel-order', { orderId, response });
          if (response.ret) {
            this.$alert({
              msg: `拉取订单列表失败. ${response.msg}`,
            });
            return;
          }
          this.$alert('订单取消成功!');
          this.showOrderList = false;
        } catch (error) {
          console.error('【PAYMENT】 cancel order error', error);
          this.$aegis.report({
            msg: 'payId取消订单 ajax 错误',
            level: this.$aegis.logType.AJAX_ERROR,
            ext1: error.message,
            ext2: orderId,
            ext3: this.payId,
            trace: error.stack,
          });
        }
      } else {
        // sku 模式取消订单
        try {
          const response = await this.$requestInstance.post(SKU_CANCEL_ORDER_API_BASE, postData);
          console.info('【PAYMENT】order cancel response', response);
          this.$emit('cancel-order', { orderId, response });
          if (response.ret) {
            this.$alert({
              msg: `拉取订单列表失败. ${response.msg}`,
            });
            return;
          }
          this.$alert('订单取消成功!');
          this.showOrderList = false;
        } catch (error) {
          console.error('【PAYMENT】 cancel order error', error);
          this.$aegis.report({
            msg: 'sku 取消订单 ajax 错误',
            level: this.$aegis.logType.AJAX_ERROR,
            ext1: error.message,
            ext2: orderId,
            ext3: this.sku.goods_list,
            trace: error.stack,
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import './styles.scss';

$pageHeight: 0.7rem;

.order-list {
  font-size: 0.2rem;
  background-size: 100% 100%;

  width: 7.2rem;
  height: calc(100% - $pageHeight);
}

.order-list-content {
  text-align: center;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: scroll;
}

.order-list-item {
  width: 90%;
  margin: 0 auto;
  margin-top: 0.3rem;
  padding: 0.1rem 0.3rem;
  white-space: nowrap;
}

.order-list-item-header {
  font-size: 0.24rem;
  display: flex;
  justify-content: space-between;
}

.order-list-item-footer {
  line-height: 0.6rem;
  font-size: 0.24rem;
  display: flex;
  justify-content: space-between;
}

.order-list-item-goods {
  font-weight: bold;
}

.order-list-item-price {
  font-weight: bold;
}

.order-list-item-right {
  float: right;
}

.order-list--default .item-link {
  margin-left: 0.1rem;
  text-decoration: underline;
}

.reward-page {
  position: absolute;
  width: 100%;
  bottom: 0px;
}

.order-list--default .reward-page {
  height: $pageHeight;
}

/* pc */

.order-list--pc {
  font-size: 20px;
  width: 720px;
}

.order-list--pc .order-list-item {
  margin-top: 6px;
  padding: 2px 6px;
}

.order-list--pc .order-list-item-header {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
}

.order-list--pc .order-list-item-footer {
  line-height: 30px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
}

.order-list--pc .item-link {
  margin-left: 10px;
}

.order-list--pc .reward-page {
  margin-top: 28px;
}
</style>
